module.exports = __webpack_public_path__ + "img/bigDataError.2c3763ec.png";